import React, { useState } from "react";
import "./HomePage.css";
import logo from "../Images/logoPharma.png";
import FacebookIcon from "@mui/icons-material/Facebook";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import InstagramIcon from "@mui/icons-material/Instagram";
import TwitterIcon from "@mui/icons-material/Twitter";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import { Drawer, IconButton, Snackbar, Stack } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import { Link } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import Box from "@mui/material/Box";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import Button from "@mui/material/Button";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import InboxIcon from "@mui/icons-material/MoveToInbox";
import MailIcon from "@mui/icons-material/Mail";
import AboutImg2 from "../Images/aboutimg2.jpg";
import AboutImg1 from "../Images/aboutimg.jpg";
import { AnimatePresence, motion } from "framer-motion";
import { Fade } from "react-reveal";
import { useContext } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate } from "react-router-dom";
import { useAlert } from "react-alert";
import Loader from "../Miscellaneous/Loader/Loader";

const HomePage = () => {
  // const alert = useAlert();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isLoading, setisLoading] = useState(false);
  const isMobile = useMediaQuery("(max-width: 906px)");

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeDrawer = () => {
    setIsMobileMenuOpen(false);
  };
  const servicesData = [
    {
      id: "web",
      title: "Web Development",
      description:
        "Our web development team creates modern and responsive websites...",
    },
    {
      id: "app",
      title: "App Development",
      description:
        "We specialize in developing innovative mobile applications...",
    },
    {
      id: "design",
      title: "Design Services",
      description:
        "Our design experts create visually stunning and user-friendly designs...",
    },
  ];
  const worksData = [
    {
      id: 1,
      title: "Project 1",
      description: "Description of Project 1",
      imageUrl: "/path-to-image1.jpg",
    },
    {
      id: 2,
      title: "Project 2",
      description: "Description of Project 2",
      imageUrl: "/path-to-image2.jpg",
    },
    // Add more work items as needed
  ];
  const [state, setState] = React.useState({
    open: false,
    vertical: "top",
    horizontal: "center",
  });
  const { vertical, horizontal, open } = state;

  const handleClick = (newState) => () => {
    setState({ ...newState, open: true });
  };

  const handleClose = () => {
    setState({ ...state, open: false });
  };
  const action = (
    <React.Fragment>
      <Button color="secondary" size="small" onClick={handleClose}>
        UNDO
      </Button>
      <IconButton
        size="small"
        aria-label="close"
        color="inherit"
        onClick={handleClose}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </React.Fragment>
  );

  return (
    <>
      <Loader isLoading={isLoading} />
      {!isLoading && (
        <div style={{ margin: "0" }}>
          <section class="hero">
            <div class="main-width">
              <header className="homepage-header">
                <div class="logo">
                  <img src={logo} alt="" width={"200rem"} height={"50rem"} />
                </div>
                <nav>
                  {isMobile && (
                    <div
                      style={{ cursor: "pointer" }}
                      onClick={toggleMobileMenu}
                    >
                      <MenuIcon color="success" />
                    </div>
                  )}
                  {!isMobile && (
                    <ul
                      style={{ marginLeft: "100px" }}
                      className={`nav-list ${isMobileMenuOpen ? "hide" : ""}`}
                    >
                      <li
                        class="btn1"
                        style={{ marginTop: "-10px", marginLeft: "110px" }}
                      >
                        {/* <ConnectButton /> */}
                        <Button
                          onClick={handleClick({
                            vertical: "bottom",
                            horizontal: "center",
                          })}
                          style={{ color: "white", borderRadius: "24px",backgroundColor: "#4169E1" }}
                          variant="contained"
                        >
                          Connect Wallet
                        </Button>
                        <Snackbar
                          anchorOrigin={{ vertical, horizontal }}
                          open={open}
                          autoHideDuration={6000}
                          onClose={handleClose}
                          message="METAMASK NOT DETECTED "
                          action={action}
                          key={vertical + horizontal}
                        />
                      </li>
                    </ul>
                  )}
                </nav>
              </header>

              <div className="container">
                <div className="hero-text">
                  <h3>Hi, There !</h3>
                  <div className="h1">
                    This is <span>PharmaVerse</span>
                  </div>
                  <p style={{ fontWeight: 700 }}>
                    Pioneering the Future of Healthcare and Pharmaceutical
                    Management through Blockchain Innovation, Enhancing
                    Transparency, Efficiency, and Trust in the Medical
                    Ecosystem.
                  </p>
                  <div className="social">
                    <a href="#">
                      <FacebookIcon
                        color="primary"
                        sx={{ fontSize: 30, color: "whitesmoke" }}
                      />
                    </a>
                    <a href="#">
                      <LinkedInIcon
                        color="primary"
                        sx={{ fontSize: 30, color: "whitesmoke" }}
                      />
                    </a>
                    <a href="#">
                      <InstagramIcon
                        color="primary"
                        sx={{ fontSize: 30, color: "whitesmoke" }}
                      />
                    </a>
                    <a href="#">
                      <TwitterIcon
                        color="primary"
                        sx={{ fontSize: 30, color: "whitesmoke" }}
                      />
                    </a>
                  </div>
                  <Stack
                    sx={{ justifyContent: "center", alignItems: "center" }}
                    direction={"row"}
                  ></Stack>
                </div>
              </div>
            </div>
          </section>

          <Drawer
            anchor="left"
            open={isMobileMenuOpen}
            onClose={isMobile ? toggleMobileMenu : closeDrawer}
          >
            <div class="logo" style={{ marginLeft: "18px", marginTop: "10px" }}>
              <img src={logo} alt="" width={"200rem"} height={"50rem"} />
            </div>
            <Divider sx={{ width: "100%" }} />
            <div
              style={{
                width: "250px",
                padding: "20px",
              }}
            >
              <List>
                <ListItem
                  sx={{ textAlign: "center", justifyContent: "center" }}
                >
                  {/* <ListItemText primary="Home" sx={{textAlign:"center" }}/> */}
                  <li>
                    <a
                      href="#"
                      style={{ textDecoration: "none", color: "white" }}
                    >
                      Home
                    </a>
                  </li>
                </ListItem>
                <ListItem
                  sx={{ textAlign: "center", justifyContent: "center" }}
                >
                  {/* <ListItemText primary="About" sx={{ textAlign: "center" }} /> */}
                  <li>
                    <a
                      href="#"
                      style={{ textDecoration: "none", color: "white" }}
                    >
                      About
                    </a>
                  </li>
                </ListItem>

                <ListItem
                  sx={{
                    textAlign: "center",
                    justifyContent: "center",
                    marginBottom: "24px",
                  }}
                >
                  <li class="btn">
                    <a
                      href="#"
                      style={{
                        textDecoration: "none",
                        color: "white",
                      }}
                    >
                      Contact Us
                    </a>
                  </li>
                </ListItem>

                <ListItem
                  sx={{ textAlign: "center", justifyContent: "center" }}
                >
                  <div class="btn1">
                    {/* <ConnectButton /> */}
                    <Button
                      onClick={handleClick}
                      style={{ color: "white", borderRadius: "24px",backgroundColor: "#4169E1" }}
                      variant="contained"
                    >
                      Connect Wallet
                    </Button>
                    <Snackbar
                      anchorOrigin={{ vertical, horizontal }}
                      open={open}
                      autoHideDuration={6000}
                      onClose={handleClose}
                      message="METAMASK NOT DETECTED "
                      action={action}
                      key={vertical + horizontal}
                    />
                  </div>
                </ListItem>
              </List>
            </div>
            <Divider sx={{ width: "100%" }} />
          </Drawer>
          <div className="bottom" style={{ padding: "0" }}>
            <p>© 2023 Upsilon - All Rights Reserved</p>{" "}
          </div>
        </div>
      )}
    </>
  );
};
export default HomePage;
